import { useNavigate, Link } from 'react-router-dom';
import { useRegister } from '../../hooks/auth/useRegister.js';
import SuccessModal from '../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../components/modales/ErrorModal.jsx';
import ValidationErrors from '../../components/alerts/ValidationErrors.jsx';
import ROUTES from '../../routes/Routes.js';
import imgRegister from '../../images/auth/register.svg';

export default function Register() {
    const navigate = useNavigate();
    const {
        form,
        handleChange,
        submit,
        error,
        success,
        validationErrors,
        clearError,
        clearSuccess,
        clearValidationErrors
    } = useRegister();

    const handleSubmit = async (e) => {
        e.preventDefault();
        await submit();
    };

    return (
        <>
            <section className="pt-4 pb-4">
                <div className="container h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-lg-12 col-xl-11">
                            <div className="card rounded-4">
                                <div className="card-body p-md-5">
                                    <div className="row justify-content-center">
                                        <div className="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
                                            <p className="text-center h1 fw-bold mb-5 mx-1 mx-md-4">Regístrate</p>
                                            {/* Muestra el error del validator del backend */}
                                            <ValidationErrors errors={validationErrors} onClose={clearValidationErrors} />
                                            <form className="mx-1 mx-md-4" onSubmit={handleSubmit}>
                                                <div className="d-flex flex-row align-items-center mb-4">
                                                    <div className="form-floating flex-fill mb-0">                                                        
                                                        <input className="form-control" id="floatingName" placeholder="Nombre" name="name" type="text" maxLength="100" value={form.name} onChange={handleChange} required />
                                                        <label htmlFor="floatingName">Nombre *</label>
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-row align-items-center mb-4">                                                    
                                                    <div className="form-floating flex-fill mb-0">
                                                        <input className="form-control" id="floatingLastname" placeholder="Apellidos" name="lastname" type="text" maxLength="100" value={form.lastname} onChange={handleChange} required  />
                                                        <label htmlFor="floatingLastname">Apellidos *</label>
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-row align-items-center mb-4">                                                    
                                                    <div className="form-floating flex-fill mb-0">
                                                        <input className="form-control" id="floatingUsername" placeholder="Nombre de usuario" name="username" type="text" maxLength="30" value={form.username} onChange={handleChange} autoComplete="username" required /> 
                                                        <label htmlFor="floatingUsername">Nombre de usuario *</label>
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-row align-items-center mb-4">                                                    
                                                    <div className="form-floating flex-fill mb-0">
                                                        <input className="form-control" id="floatingEmail" placeholder="Email" name="email" type="email" maxLength="50" value={form.email} onChange={handleChange} autoComplete="email" required />
                                                        <label htmlFor="floatingEmail">Email *</label>
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-row align-items-center mb-4">                                                    
                                                    <div className="form-floating flex-fill mb-0">
                                                        <input className="form-control" id="floatingPassword" placeholder="Contraseña" name="password" type="password" maxLength="255" value={form.password} onChange={handleChange} autoComplete="new-password" required />
                                                        <label htmlFor="floatingPassword">Contraseña *</label>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-center mx-4">
                                                    <button type="submit" className="btn btn-primary">Crear cuenta</button>
                                                    <Link to={ROUTES.LOGIN}  type="button" className="ms-3 btn btn-secondary">Cancelar</Link>                                                    
                                                </div> 
                                            </form>
                                        </div>
                                        <div className="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">                                            
                                                <img src={imgRegister} className="img-fluid m-auto" alt="crear_cuenta" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <SuccessModal
                show={!!success}
                message={success}
                onClose={() => {
                    clearSuccess();
                    navigate(ROUTES.LOGIN);
                }}
            />

            <ErrorModal
                show={!!error}
                message={error}
                onClose={clearError}
            />
        </>
    );
}
